<template>
  <BannerLayout>
    <template #text>
      <div
        :class="[
          'grid grid-cols-1 sm:grid-cols-[min-content,1fr] gap-x-2 grid-flow-col sm:grid-flow-row',
          $slots.subText
            ? 'grid-rows-repeat(3, auto) md:grid-rows-[auto,1fr]'
            : 'grid-rows-[min-content_1fr] sm:grid-rows-1'
        ]"
      >
        <slot name="consultationPill" />

        <slot name="mainText" />

        <div v-if="$slots.subText" class="col-start-1 row-start-3 sm:col-start-2 sm:row-start-2">
          <slot name="subText" />
        </div>
      </div>
    </template>

    <template #actions>
      <slot name="actions" />
    </template>
  </BannerLayout>
</template>

<script setup lang="ts">
import BannerLayout from '@/atoms/BannerLayout.vue'
</script>

<style scoped></style>
